import gql from 'graphql-tag';

export const redeemReferralCodeByAccountId =
  client =>
  ({ accountId, referralCode }) =>
    client.mutate({
      mutation: gql`
        mutation redeemReferralCodeByAccountId($input: RedeemInput!) {
          redeemReferralCodeByAccountId(input: $input) {
            message
          }
        }
      `,
      variables: { input: { accountId, referralCode } }
    });

export default { redeemReferralCodeByAccountId };
